import queryString from 'query-string';
import { GestureResponderEvent } from 'react-native';
import { getQuery } from '../const';
import { radar } from '../log';
import { getAppProps } from '@/AppProps';

const INP_VALID_CLICK_DURATION = 1000;
const INP_QUERY_KEY = 'INP_TIMESTAMP';
const inpCurrentEvent = { target: 0, time: 0 };
const setInpCurrentEvent = (target: number, time: number) => {
    inpCurrentEvent.target = target;
    inpCurrentEvent.time = time;
};

// 记录最近一次点击信息
export const updateInpCurrentEvent = (event: GestureResponderEvent) => {
    const time = Date.now();
    const target = event?.target;
    const isValidClick = (() => {
        // 第一次点击
        if (!inpCurrentEvent.target && !inpCurrentEvent.time) {
            return true;
        }
        // 点击不同区域
        if (target !== inpCurrentEvent.target) {
            return true;
        }
        // 点击相同区域但两次间隔大于阈值
        if (time - inpCurrentEvent.time >= INP_VALID_CLICK_DURATION) {
            return true;
        }
        return false;
    })();

    if (isValidClick) {
        setInpCurrentEvent(target, time);
    }
};

// 将信息添加到 URL 上
export const addInpQueryToUrl = (url: string) => {
    if (!inpCurrentEvent.target || !inpCurrentEvent.time) {
        return url;
    }
    if (inpCurrentEvent.time <= 0) {
        return url;
    }
    return queryString.stringifyUrl({
        url,
        query: {
            [INP_QUERY_KEY]: inpCurrentEvent.time,
        },
    });
};

// 上报 INP
export const reportInp = () => {
    const { onCreateTimestamp, source, sourceBundle } = getAppProps() || {};
    const startTime = getQuery(INP_QUERY_KEY);
    if (onCreateTimestamp && startTime) {
        const cost = onCreateTimestamp - Number(startTime);
        console.log('[inp] cost =>', cost);
        radar.event({
            name: 'SHOP_KRN_INP_URL_COST',
            params: {
                cost,
                source: sourceBundle || source || 'unknown',
            },
        });
    }
};
